import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Vehicle, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService extends BaseApiService<Vehicle> {
  get cacheKey(): StorageKey {
    return StorageKey.vehicleServiceCache;
  }
  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/vehicles`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  list(params: {[params: string]: string}): Promise<Pagination<Vehicle>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Vehicle.unparse(obj);
  }

  protected parse(obj) {
    return Vehicle.parse(obj);
  }

}
